import {
  HotelsConfigProvider as CoreHotelsConfigProvider,
  type HotelsConfigProviderProps,
} from "@b2bportal/core-hotels";

import { Experiments, useExperiment } from "@tenant/experiments";

export const HotelsConfigProvider = ({
  children,
  config,
}: HotelsConfigProviderProps) => {
  const { isExperimentVariant, isLoading, data } = useExperiment();
  const isHomesEnabledExperiment = isExperimentVariant(
    Experiments.HOMES.name,
    Experiments.HOMES.variants.available
  );
  const isFilterUnavailableLodgingsExperiment = isExperimentVariant(
    Experiments.FILTER_UNAVAILABLE_LODGINGS.name,
    Experiments.FILTER_UNAVAILABLE_LODGINGS.variants.available
  );

  const hotelsConfig = {
    ...config,
    // Use the static config value as fallback while experiments are loading
    // This matches the experiment's fallback value (available) in experimentDefaults.ts
    enableHomes:
      isLoading || !data ? config.enableHomes : isHomesEnabledExperiment,
    filterUnavailableLodgings:
      isLoading || !data
        ? config.filterUnavailableLodgings
        : isFilterUnavailableLodgingsExperiment,
  };

  return (
    <CoreHotelsConfigProvider config={hotelsConfig}>
      {children}
    </CoreHotelsConfigProvider>
  );
};
